export const handleSheetOpen = (financeSheetId) => {
    const url = `https://docs.google.com/spreadsheets/d/${financeSheetId}/edit#gid=472851648`;
    console.log(url);
    window.open(url, "_blank");
  };
  